import { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import swal from 'sweetalert2';
import moment from "moment";
import MatchPlayList  from "./matchPlayList";
import { deleteMatchPlayRegister, getRegistrationData, postMatchPlayRegistration } from "../api/matchPlayAPI";
import { isCancel } from "axios";


const str_Single    = "Singles";
const str_Double    = "Doubles";

const RegisterModal = (props) => { 
    const [mData,           setMData]           = useState({});
    const [mRegister,       setMregister]       = useState({});
    const [players,         setPlayers]         = useState([]);
    const [player1,         setPlayer1]         = useState([]);
    const [player2,         setPlayer2]         = useState([]);

    //#region Effects   
    useEffect(() => {
        $("#registerModal").modal({ backdrop: "static" });      
        $("#registerModal").on("hidden.bs.modal",()=>{ 
            clearModalStates();
            props?.onDismissModal() 
        });    
    }, [props?.show]);

    useEffect(() => {
        if (players && players.length > 0) {
            if (mRegister) {
                const filteredPlayer1 = players.filter(p => (p.value.ID != mRegister.User2ID || p.value.UserType != mRegister.User2Type))
                const filteredPlayer2 = players.filter(p => (p.value.ID != mRegister.User1ID || p.value.UserType != mRegister.User1Type))
                
                setPlayer1(filteredPlayer1)
                setPlayer2(filteredPlayer2)
                
            }
        }
    }, [mRegister, players])

    useEffect(()=>{       
        if(props?.mData) {
            let AllPlayers = [];
            const { UnRegistered } = props?.mData;
           
            setMData({...props?.mData, UnRegistered});                    
    
            if(UnRegistered?.length > 0) {
                AllPlayers = UnRegistered.map(r =>({label:`${r.Name} ${ r?.Handicap == null ? ` (NH)`: ` (${r?.Handicap})`} ${r?.UserType == 'Guest'? ' (G)':''} `, value: r }));                
            }
            
            //For Edits          
            if(!!props?.selectedRegister) {
                const {selectedRegister} = props;
                
                setMregister(selectedRegister);  

                const players = [{
                    label : `${selectedRegister.User1Name} (${selectedRegister.User1Handicap}) ${(selectedRegister.User1Type == "Guest") ? '(G)':''}`,
                    value : {
                        ID       : selectedRegister.User1ID,
                        UserType : selectedRegister.User1Type,
                        Name     : selectedRegister.User1Name,
                        Email    : selectedRegister.User1Email,
                        DOB      : selectedRegister.User1DOB,                        
                        Handicap    : selectedRegister.User1Handicap,                              
                        MembershipNo: selectedRegister.User1MembershipNo,                       
                    },
                }]
               
                //Update for Doubles 
                if(props?.mMaster?.Type != str_Single){
                    for (let index = 2; index <= 4 ; index++) {
                        const cPlayerID = selectedRegister[`User${index}ID`];
                        if(!!cPlayerID){
                            players.push({
                                label : `${selectedRegister[`User${index}Name`]} (${selectedRegister[`User${index}Handicap`]}) ${(selectedRegister[`User${index}Type`] == "Guest") ? '(G)':''}`,
                                value : {
                                ID          : cPlayerID,
                                UserType    : selectedRegister[`User${index}Type`],
                                Name        : selectedRegister[`User${index}Name`],
                                Email       : selectedRegister[`User${index}Email`],
                                DOB         : selectedRegister[`User${index}DOB`],                        
                                Handicap    : selectedRegister[`User${index}Handicap`],                              
                                MembershipNo: selectedRegister[`User${index}MembershipNo`],                       
                            }});                    
                        }
                    }
                }

                AllPlayers = [...AllPlayers, ...players];
            }
                   
            setPlayers(AllPlayers);         
        }        
    },[props]);   
         
    //#endregion

    //#region API Calls
    const postMatchPlayRegister = async() => {      
        try {
            swal.fire({ titleText: 'Loading', text: 'Please Wait...', showConfirmButton: false, onOpen: () => swal.showLoading(),  allowOutsideClick: false, allowEscapeKey: false, });

            //Check Users and Handicap
            const isValidUsers = checkUsers();
            if(!isValidUsers) return;

            let matchPlayRegister = {MatchPlayID:props?.mMaster?.ID , ...mRegister};

            //For add Only
            if(!props?.selectedRegister) matchPlayRegister.ID = 0;
                  
            await postMatchPlayRegistration(matchPlayRegister);
            
            swal.fire({
                icon: 'success', timer: 1500, animation: false, toast: true,
                position: 'bottom-end', showConfirmButton: false, customClass: { popup: 'margin-20' },
                titleText: 'MatchPlay Registration Added successfully!',
                onOpen: () => swal.hideLoading()
            });
                        
            props.refetchData();
            $("#registerModal").modal('hide');                        
        } catch (err) {           
            swal.fire({ icon :'error', titleText : err.message,  onOpen: () => swal.hideLoading() })
        }
    }

    const checkUsers = () => {
        let isValid = true;
        //Check User1ID With All ID's in Registration 
        if(!mRegister.User1ID || (props?.mMaster?.Type != str_Single && !mRegister.User2ID)){          
            swal.fire({ icon: 'warning', timer: 900, showConfirmButton: false, titleText: 'Please select player!', onOpen: () => swal.hideLoading(),});
            return isValid = false;
        }
        
        let isUser1Exist = mData?.MatchPlayRegister?.find(u => (u.User1ID == mRegister?.User1ID && u.User1Type == mRegister?.User1Type) || (u.User2ID == mRegister?.User1ID && u.User2Type == mRegister?.User1Type));
        let isWaiting    = false;
        
        if (!isUser1Exist) {   //Check User1ID With All ID's in Waiting  
            isUser1Exist = mData?.MatchPlayWaiting?.find(u => (u.User1ID == mRegister?.User1ID && u.User1Type == mRegister?.User1Type) || (u.User2ID == mRegister?.User1ID && u.User2Type == mRegister?.User1Type));
            isWaiting    = true;
        }

        if (isUser1Exist && ((isWaiting && isUser1Exist.ID != mRegister?.ID) || (!isWaiting && isUser1Exist.ID != mRegister?.ID))) {          
            swal.fire({ icon: 'warning', timer: 900, showConfirmButton: false, titleText: 'Player 1 already exists!', onOpen: () => swal.hideLoading() });           
            return  isValid = false;
        }
       
        if (props?.mMaster?.Type != str_Single) {
            let isUser2Exist =  mData?.MatchPlayRegister?.find(u => (u.User1ID == mRegister?.User2ID && u.User1Type == mRegister?.User2Type) || (u.User2ID == mRegister?.User2ID && u.User2Type == mRegister?.User2Type));
            isWaiting        = false;

            if (!isUser2Exist) {
                isUser2Exist = mData?.MatchPlayWaiting?.find(u => (u.User1ID == mRegister?.User2ID && u.User1Type == mRegister?.User2Type) || (u.User2ID == mRegister?.User2ID && u.User2Type == mRegister?.User2Type));
                isWaiting    = true;
            }

            if (isUser2Exist && ((isWaiting && isUser2Exist.ID != mRegister?.ID) || (!isWaiting && isUser2Exist.ID != mRegister?.ID))) {              
                swal.fire({ icon: 'warning', timer: 900, showConfirmButton: false, titleText: 'Player 2 already exists!', onOpen: () => swal.hideLoading()});
                return isValid = false;
            } 
        }
        return  isValid; 
    }
    
    //#endregion

    //#region handlers  

    const onChangeHandler = (field, value)=> {

        setMregister(r => ({...r, [field]:value}));
    }

    const onPlayerSelect = (playerdd, player)=> {       
        if(!player) return;                           
        setMregister(r => ({...r, [`${playerdd}ID`]: player.ID, [`${playerdd}Handicap`]: player.Handicap, [`${playerdd}Type`]: player.UserType , IsCancel : "N", FromAdmin : "Y"}));
    }

    const clearModalStates =()=>{
        setMregister({});
        setPlayers([]);
    
    }

    //#endregion

    return(<>
        <div className="modal fade" id="registerModal" tabIndex="-1" role="dialog" aria-hidden="true">       
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title"> MatchPlay Registration </h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"></button>
                    </div>         
                    <div className="modal-body bg-grey">

                        <div className="kt-portlet">
                            <div className="kt-portlet__body">
                                <div className="kt-widget kt-widget--user-profile-3">
                                    <div className="form-group row">
                                        <label className="col-form-label offset-lg-1 col-lg-3"> Player 1 <span className="red">*</span></label>
                                        <div className="col-xl-6 col-lg-8">
                                            <div className="input-group ddlMobilePnl">                                            
                                                <Select                                       
                                                    id       = "ddlPlayer1" className="width-100p" name= "ddlPlayer1" placeholder= "Select Player 1"
                                                    options  = {player1 || []}
                                                    value    = {(players.length > 0 && mRegister?.User1ID) && players.find(m => (m.value.ID == mRegister?.User1ID) && (m.value.UserType == mRegister?.User1Type) )}
                                                    isDisabled={(!!props?.selectedRegister)}
                                                    onChange = {(event) => onPlayerSelect('User1', event.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {props?.mMaster?.Type != str_Single && (                            
                                        <div className="form-group row player2-holder">
                                            <label className="col-form-label offset-lg-1 col-lg-3"> Player 2 <span className="red">*</span></label>
                                            <div className="col-xl-6 col-lg-8">
                                                <div className="input-group ddlMobilePnl">
                                                    <Select                                       
                                                        id       = "ddlPlayer2" className="width-100p" name= "ddlPlayer2" placeholder= "Select Player 2"
                                                        options  = {player2 || []}  isDisabled={(!!props?.selectedRegister)}
                                                        value    = {(players.length > 0 && mRegister?.User2ID) && players.find(m =>(m.value.ID == mRegister?.User2ID) && (m.value.UserType == mRegister?.User2Type))}
                                                        onChange = {(event) => onPlayerSelect('User2',event.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}                   
                                
                                    <div className="form-group row">
                                        <label className="col-form-label offset-lg-1 col-lg-3"> Special Request </label>
                                        <div className="col-xl-6 col-lg-8">
                                            <textarea id="txtComment" name="txtComment" className="form-control width-340" rows="3"
                                                value={mRegister?.Comment || ''}
                                                onChange={({target}) => onChangeHandler('Comment', target.value)}
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>                    
                    </div>
                    <div className="modal-footer">
                        <button type="button" id="btnSubmit" className="btn btn-primary margin-0 margin-r5" onClick={postMatchPlayRegister} > Save </button>                                                       
                        <button type="button" className="btn btn-secondary margin-0 margin-r5" data-dismiss="modal"> Close </button>                                                       
                    </div>            
                </div>
            </div>
        </div>
 </>);
}


const MatchPlayRegistration = (props) => { 
    const [isInit, setIsInit]       = useState(true);
    const history                   = useHistory();
    const [showModal, setShowModal] = useState(false);
    const [mMaster,   setMMaster]   = useState();
    const [pageData, setPageData] = useState({});
    const [IsDeadlineCreated, setIsDeadlineCreated] = useState(false);
   
    const [selectedRegister, setSelectedRegister] = useState(null);
    const [matchPlayID,   setMatchPlayID]   = useState();

    //#region Effects ---
    useEffect(() => {
        props.title("Registration", "matchplay-register");   
        const path = history.location.pathname
        const splitedPath = path.split('/')
        const mID = splitedPath?.find(p => !isNaN(p) && p !== '');
        setMatchPlayID(mID)        
    },[]);
    
    useEffect(() => {     
        if(!!mMaster) fetchMatchPlayData(mMaster?.ID);                                 
    },[mMaster]);

    useEffect(() => {
        if (!isInit) {
            $('#tblMatchPlayRegister').KTDatatable().destroy();
            $('#tblMatchPlayWaiting').KTDatatable().destroy();
            fillRegistraionTable(pageData?.MatchPlayRegister, pageData?.MatchPlayWaiting);
        }
    }, [isInit]);

    //#endregion

    //#region Api Call's
    const fetchMatchPlayData = async(matchPlayId)=> {
        try {
            if(!matchPlayId) return;
            swal.fire({ showConfirmButton: false, onOpen:() => swal.showLoading(), titleText: 'Loading', text: 'Please Wait...',  allowOutsideClick: false, allowEscapeKey: false,});
            const res = await getRegistrationData(matchPlayId);
            if(!!res) {                             
               
                setPageData(res);                            

                if(isInit){
                    setIsInit(false);
                    fillRegistraionTable(res?.MatchPlayRegister, res?.MatchPlayWaiting);
                }else{
                    $('#tblMatchPlayRegister').KTDatatable().destroy();
                    $('#tblMatchPlayWaiting').KTDatatable().destroy();
                    fillRegistraionTable(res?.MatchPlayRegister, res?.MatchPlayWaiting);
                }       
                // if (isInit)
                //     setIsInit(false)     
            }              
            swal.close();
        } catch (err) {          
            swal.fire({ icon :'error', titleText : err.message, onOpen:() => swal.hideLoading() })
        }            
    }

    const deleteMatchPlayRegistration = async(registerId, type)=>{
        try {
            const result = await swal.fire({
                title: 'Cancel Player Registration',
                text: 'Are you sure want to cancel registration?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
            });
            
            if (!result.isConfirmed) return;
            swal.fire({ showConfirmButton: false, onOpen: () => swal.showLoading(), titleText: 'Loading', text: 'Please Wait...', allowOutsideClick: false, allowEscapeKey: false, });
            await deleteMatchPlayRegister(registerId, type);

            swal.fire({
                icon: 'success', toast: true, position: 'bottom-end', timer: 1500,
                showConfirmButton: false, animation: false, customClass: { popup: 'margin-20' },
                titleText: 'MatchPlay Registration Deleted successfully!',
                onOpen: () => swal.hideLoading()
            });

            refetchMatchPlayData();

        } catch (err) {
            swal.fire({ icon: 'error', titleText: err.message, onOpen: () => swal.hideLoading() })
        }
    }

    //#endregion

    //#region Handler    
    const GetFilteredList = (regList, waitList)=> {
        let filteredRegisterList = regList || pageData?.MatchPlayRegister || [];
        let filteredWaitingList  = waitList || pageData?.MatchPlayWaiting || [];  
            
        return { filteredRegisterList, filteredWaitingList }
    }
    
    const fillRegistraionTable =(regList, waitList)=> {
    
        let dataTableFields = [    
            {
                field: 'User1ID', maxWidth: 200,
                title: (mMaster?.Type == 'Singles') ? 'Player' : 'Player 1',
                width: (mMaster?.Type == 'Doubles') ? 230 : 200,
                template:(row)=> {
                    const userHandicap = (row?.User1Handicap < 0) ? `+ ${Math.abs(row.User1Handicap)}` : row.User1Handicap;

                    return( `<div class="row">
                        <div class="col-10">
                            <div class="kt-user-card-v2">
                                <div class="kt-user-card-v2__pic">
                                    ${((row.User1Photo) && (row.User1Photo != '') && (row.User1Photo != 'user.png')) ? `<img src="${row.User1Photo}" alt="user-Photo" >` : ` <div class="kt-badge kt-badge--xl kt-badge--info" > ${row.User1Name.substring(0, 1)}</div >`}
                                </div>
                                <div class="kt-user-card-v2__desc text-clip">
                                    ${((row.User1Name) && (row.User1Name != '')) ?
                                    `<span class="kt-user-card-v2__name text-clip"> ${row.User1Name} (${userHandicap}) </span>` : ''}
                                </div>
                                </div>
                        </div>     
                        <div  class="col-2">
                            ${row.FromAdmin == 'Y' ? `
                            <svg viewBox="0 0 24 24" version="1.1" class="kt-svg-icon" style="height:30px; width:30px; float:right;">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <rect x="0" y="0" width="24" height="24"/>
                                    <path d="M5,5 L5,16 L19,16 L19,5 L5,5 Z M5,3 L19,3 C20.4201608,3 21,3.7163444 21,4.6 L21,17.4 C21,18.2836556 20.4201608,19 19,19 L5,19 C3.57983921,19 3,18.2836556 3,17.4 L3,4.6 C3,3.7163444 3.57983921,3 5,3 Z M12,18 C12.2761424,18 12.5,17.7761424 12.5,17.5 C12.5,17.2238576 12.2761424,17 12,17 C11.7238576,17 11.5,17.2238576 11.5,17.5 C11.5,17.7761424 11.7238576,18 12,18 Z" fill="#000000" fill-rule="nonzero"/>
                                    <polygon fill="#000000" opacity="0.3" points="5 5 5 16 19 16 19 5"/>
                                    <rect fill="#000000" opacity="0.3" x="10" y="20" width="4" height="1" rx="0.5"/>
                                </g>
                            </svg>
                            ` : `
                            <svg viewBox="0 0 24 24" version="1.1" class="kt-svg-icon" style="height:30px; width:30px; float:right;">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <rect x="0" y="0" width="24" height="24"/>
                                    <path d="M8,2.5 C7.30964406,2.5 6.75,3.05964406 6.75,3.75 L6.75,20.25 C6.75,20.9403559 7.30964406,21.5 8,21.5 L16,21.5 C16.6903559,21.5 17.25,20.9403559 17.25,20.25 L17.25,3.75 C17.25,3.05964406 16.6903559,2.5 16,2.5 L8,2.5 Z" fill="#000000" opacity="0.3"/>
                                    <path d="M8,2.5 C7.30964406,2.5 6.75,3.05964406 6.75,3.75 L6.75,20.25 C6.75,20.9403559 7.30964406,21.5 8,21.5 L16,21.5 C16.6903559,21.5 17.25,20.9403559 17.25,20.25 L17.25,3.75 C17.25,3.05964406 16.6903559,2.5 16,2.5 L8,2.5 Z M8,1 L16,1 C17.5187831,1 18.75,2.23121694 18.75,3.75 L18.75,20.25 C18.75,21.7687831 17.5187831,23 16,23 L8,23 C6.48121694,23 5.25,21.7687831 5.25,20.25 L5.25,3.75 C5.25,2.23121694 6.48121694,1 8,1 Z M9.5,1.75 L14.5,1.75 C14.7761424,1.75 15,1.97385763 15,2.25 L15,3.25 C15,3.52614237 14.7761424,3.75 14.5,3.75 L9.5,3.75 C9.22385763,3.75 9,3.52614237 9,3.25 L9,2.25 C9,1.97385763 9.22385763,1.75 9.5,1.75 Z" fill="#000000" fill-rule="nonzero"/>
                                </g>
                            </svg>`}
                        </div>
                    </div>`);
                },            
            },
            {
                field: 'Created', title: 'Reg. Date', width: 120,
                template: (row)=> moment(row.Created).format('DD-MMM-YYYY'),
            },
            
            {
                field: 'TeeBoxID', title: 'Tee Box', width: 60,
                template: (row)=> (mMaster?.Type == 'Singles') ? row.DefaultTeeBox1Name : row.DefaultTeeBox2Name,
            },
            {
                field: '', title: 'Action', width: 100,
                template: (row)=> {
                    return (`<span class="text-center">
                        ${(!!row.Comment && row.Comment != '') ? '<button type="button" class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs margin-r5" data-toggle="kt-popover" data-trigger="hover click" data-placement="left" data-original-title="Comments" data-content=" ' + row.Comment + '"><i class="fa fa-info"></i></button>' : ''}
                        ${(row.IsScoringStarted ? '' : '<button class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs btn-delete-register" data-trigger="hover" data-offset="60px 0px" data-toggle="kt-popover" data-placement="bottom" data-content="Cancel Registration"  type="button"><i class="flaticon2-rubbish-bin-delete-button"></i></button>')}
                    </span>`);
                }
            },
        ];

        let player2Field = {
            field: 'User2ID', title:'Player 2', 
            width: (mMaster?.Type == 'Doubles') ? 230 : 200,
            // width: 230,
            template:(row)=>{
                let userHandicap = (row?.User2Handicap < 0) ? `+ ${Math.abs(row.User2Handicap)}` : row.User2Handicap;

                return (row.User2ID ? `
                    <div class="row">
                        <div class="col-10">
                            <div class="kt-user-card-v2">
                                <div class="kt-user-card-v2__pic">
                                    ${((row.User2Photo) && (row.User2Photo != '') && (row.User2Photo != 'user.png')) ? `<img src="${row.User2Photo}" alt="user-Photo" >` : ` <div class="kt-badge kt-badge--xl kt-badge--info" > ${row.User2Name.substring(0, 1)}</div >`}
                                </div>
                                <div class="kt-user-card-v2__desc text-clip">
                                    ${((row.User2Name) && (row.User2Name != '')) ?
                                    `<span class="kt-user-card-v2__name text-clip"> ${row.User2Name} (${userHandicap}) </span>` : ''}
                                </div>
                             </div>
                        </div>
                        <div  class="col-2">
                            ${row.FromAdmin == 'Y' ? `
                            <svg viewBox="0 0 24 24" version="1.1" class="kt-svg-icon" style="height:30px; width:30px; float:right;">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <rect x="0" y="0" width="24" height="24"/>
                                    <path d="M5,5 L5,16 L19,16 L19,5 L5,5 Z M5,3 L19,3 C20.4201608,3 21,3.7163444 21,4.6 L21,17.4 C21,18.2836556 20.4201608,19 19,19 L5,19 C3.57983921,19 3,18.2836556 3,17.4 L3,4.6 C3,3.7163444 3.57983921,3 5,3 Z M12,18 C12.2761424,18 12.5,17.7761424 12.5,17.5 C12.5,17.2238576 12.2761424,17 12,17 C11.7238576,17 11.5,17.2238576 11.5,17.5 C11.5,17.7761424 11.7238576,18 12,18 Z" fill="#000000" fill-rule="nonzero"/>
                                    <polygon fill="#000000" opacity="0.3" points="5 5 5 16 19 16 19 5"/>
                                    <rect fill="#000000" opacity="0.3" x="10" y="20" width="4" height="1" rx="0.5"/>
                                </g>
                            </svg>
                            ` : `
                            <svg viewBox="0 0 24 24" version="1.1" class="kt-svg-icon" style="height:30px; width:30px; float:right;">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <rect x="0" y="0" width="24" height="24"/>
                                    <path d="M8,2.5 C7.30964406,2.5 6.75,3.05964406 6.75,3.75 L6.75,20.25 C6.75,20.9403559 7.30964406,21.5 8,21.5 L16,21.5 C16.6903559,21.5 17.25,20.9403559 17.25,20.25 L17.25,3.75 C17.25,3.05964406 16.6903559,2.5 16,2.5 L8,2.5 Z" fill="#000000" opacity="0.3"/>
                                    <path d="M8,2.5 C7.30964406,2.5 6.75,3.05964406 6.75,3.75 L6.75,20.25 C6.75,20.9403559 7.30964406,21.5 8,21.5 L16,21.5 C16.6903559,21.5 17.25,20.9403559 17.25,20.25 L17.25,3.75 C17.25,3.05964406 16.6903559,2.5 16,2.5 L8,2.5 Z M8,1 L16,1 C17.5187831,1 18.75,2.23121694 18.75,3.75 L18.75,20.25 C18.75,21.7687831 17.5187831,23 16,23 L8,23 C6.48121694,23 5.25,21.7687831 5.25,20.25 L5.25,3.75 C5.25,2.23121694 6.48121694,1 8,1 Z M9.5,1.75 L14.5,1.75 C14.7761424,1.75 15,1.97385763 15,2.25 L15,3.25 C15,3.52614237 14.7761424,3.75 14.5,3.75 L9.5,3.75 C9.22385763,3.75 9,3.52614237 9,3.25 L9,2.25 C9,1.97385763 9.22385763,1.75 9.5,1.75 Z" fill="#000000" fill-rule="nonzero"/>
                                </g>
                            </svg>`}
                        </div>                                                      
                </div>` : ``)
            }
        };


        if (mMaster?.Type != str_Single) dataTableFields.splice(1, 0, player2Field);
       
        const registerList = GetFilteredList(regList, waitList);

        // const dataTable = $('#tblMatchPlayRegister').KTDatatable({
        //     data    : { saveState: false, source: registerList?.filteredRegisterList || []},
        //     layout  : { scroll: true, footer: false }, sortable: false, pagination: false,
        //     search  : { input: $('#matchPlayRegisterSearch') },
        //     columns : dataTableFields,
        //     rows    : { autoHide: false }
        // });

        const dataTable = $('#tblMatchPlayRegister').KTDatatable({
            data: {
                saveState: false,
                source: registerList?.filteredRegisterList || [],
                pageSize: 10
            },
            layout: {
                scroll: true,
                height: 700, // fixed height for scrolling
                footer: false
            },
            sortable: false,
            pagination: true,
            search: {
                input: $('#matchPlayRegisterSearch')
            },
            columns: dataTableFields,
            rows: {
                autoHide: false
            }
        });

        let waitingdataTableFields = [           
            {
                field: 'User1ID', maxWidth: 200,
                title: mMaster?.Type == 'Singles' ? 'Player' : 'Player 1',
                width: (mMaster?.Type == 'Doubles') ? 230 : 200,
                template:(row)=> {
                    let userHandicap = (row?.User1Handicap < 0) ? `+ ${Math.abs(row.User1Handicap)}` : row.User1Handicap;

                    return `<div class="row">
                        <div class="col-10">
                            <div class="kt-user-card-v2">
                                <div class="kt-user-card-v2__pic">
                                    ${((row.User1Photo) && (row.User1Photo != '') && (row.User1Photo != 'user.png')) ? `<img src="${row.User1Photo}" alt="user-Photo" >` : ` <div class="kt-badge kt-badge--xl kt-badge--info" > ${row?.User1Name ? row.User1Name.substring(0, 1) : ''}</div >`}
                                </div>
                                <div class="kt-user-card-v2__desc text-clip">
                                    ${((row.User1Name) && (row.User1Name != '')) ?
                                    `<span class="kt-user-card-v2__name text-clip"> ${row.User1Name} (${userHandicap}) </span>` : ''}
                                </div>
                            </div>
                        </div>
                        <div  class="col-2">
                            ${row.FromAdmin == 'Y' ? `
                            <svg viewBox="0 0 24 24" version="1.1" class="kt-svg-icon" style="height:30px; width:30px; float:right;">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <rect x="0" y="0" width="24" height="24"/>
                                    <path d="M5,5 L5,16 L19,16 L19,5 L5,5 Z M5,3 L19,3 C20.4201608,3 21,3.7163444 21,4.6 L21,17.4 C21,18.2836556 20.4201608,19 19,19 L5,19 C3.57983921,19 3,18.2836556 3,17.4 L3,4.6 C3,3.7163444 3.57983921,3 5,3 Z M12,18 C12.2761424,18 12.5,17.7761424 12.5,17.5 C12.5,17.2238576 12.2761424,17 12,17 C11.7238576,17 11.5,17.2238576 11.5,17.5 C11.5,17.7761424 11.7238576,18 12,18 Z" fill="#000000" fill-rule="nonzero"/>
                                    <polygon fill="#000000" opacity="0.3" points="5 5 5 16 19 16 19 5"/>
                                    <rect fill="#000000" opacity="0.3" x="10" y="20" width="4" height="1" rx="0.5"/>
                                </g>
                            </svg>` : `
                            <svg viewBox="0 0 24 24" version="1.1" class="kt-svg-icon" style="height:30px; width:30px; float:right;">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <rect x="0" y="0" width="24" height="24"/>
                                    <path d="M8,2.5 C7.30964406,2.5 6.75,3.05964406 6.75,3.75 L6.75,20.25 C6.75,20.9403559 7.30964406,21.5 8,21.5 L16,21.5 C16.6903559,21.5 17.25,20.9403559 17.25,20.25 L17.25,3.75 C17.25,3.05964406 16.6903559,2.5 16,2.5 L8,2.5 Z" fill="#000000" opacity="0.3"/>
                                    <path d="M8,2.5 C7.30964406,2.5 6.75,3.05964406 6.75,3.75 L6.75,20.25 C6.75,20.9403559 7.30964406,21.5 8,21.5 L16,21.5 C16.6903559,21.5 17.25,20.9403559 17.25,20.25 L17.25,3.75 C17.25,3.05964406 16.6903559,2.5 16,2.5 L8,2.5 Z M8,1 L16,1 C17.5187831,1 18.75,2.23121694 18.75,3.75 L18.75,20.25 C18.75,21.7687831 17.5187831,23 16,23 L8,23 C6.48121694,23 5.25,21.7687831 5.25,20.25 L5.25,3.75 C5.25,2.23121694 6.48121694,1 8,1 Z M9.5,1.75 L14.5,1.75 C14.7761424,1.75 15,1.97385763 15,2.25 L15,3.25 C15,3.52614237 14.7761424,3.75 14.5,3.75 L9.5,3.75 C9.22385763,3.75 9,3.52614237 9,3.25 L9,2.25 C9,1.97385763 9.22385763,1.75 9.5,1.75 Z" fill="#000000" fill-rule="nonzero"/>
                                </g>
                            </svg>`}
                        </div>                                                      
                    </div>`
                }
            },
            {
                field: 'Created', title: 'Reg. Date', width: 120,
                template: (row)=> moment(row.Created).format('DD-MMM-YYYY'),   
            }, 
            {
                field: 'TeeBoxID', title: 'Tee Box', width: 60,
                template: (row)=> (mMaster?.Type == 'Singles') ? row.DefaultTeeBox1Name : row.DefaultTeeBox2Name,
            },             
            {
                field: '', title: 'Action', width: 100, 
                template:(row)=> {
                    return (`<span>                           
                        ${(!!row.Comment && row.Comment != '') ? '<button type="button" class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs margin-r7" data-toggle="kt-popover" data-trigger="hover click" data-placement="left" data-original-title="Comments" data-content=" ' + row.Comment + '"><i class="fa fa-info"></i></button>' : ''}
                        ${(row.IsScoringStarted ? '' : '<button class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs margin-r5 btn-delete-waiting" data-trigger="hover" data-offset="60px 0px" data-toggle="kt-popover" data-placement="bottom" data-content="Cancel Registration"  type="button"><i class="flaticon2-rubbish-bin-delete-button"></i></button>')}
                    </span>`);
                }            
            },
        ];

        let waitingplayer2Field = {
            field: 'User2ID', title: 'Player 2',
            width: (mMaster?.Type == 'Doubles') ? 230 : 200,
            // width: 230,
            template:(row)=> {            
                const userHandicap = (row?.User2Handicap < 0) ? `+ ${ Math.abs(row.User2Handicap)}` : row.User2Handicap;

                return (row.User2ID ? `
                    <div class="row">
                        <div class="col-10">
                            <div class="kt-user-card-v2">
                                <div class="kt-user-card-v2__pic">
                                    ${((row.User2Photo) && (row.User2Photo != '') && (row.User2Photo != 'user.png')) ? `<img src="${row.User2Photo}" alt="user-Photo" >` : ` <div class="kt-badge kt-badge--xl kt-badge--info" > ${row.User2Name.substring(0, 1)}</div >`}
                                </div>
                                <div class="kt-user-card-v2__desc text-clip">
                                    ${((row.User2Name) && (row.User2Name != '')) ?
                                    `<span class="kt-user-card-v2__name text-clip"> ${row.User2Name} (${userHandicap}) </span>` : ''}
                                </div>
                            </div>
                        </div>
                        <div  class="col-2">
                            ${row.FromAdmin == 'Y' ? `
                            <svg viewBox="0 0 24 24" version="1.1" class="kt-svg-icon" style="height:30px; width:30px; float:right;">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <rect x="0" y="0" width="24" height="24"/>
                                    <path d="M5,5 L5,16 L19,16 L19,5 L5,5 Z M5,3 L19,3 C20.4201608,3 21,3.7163444 21,4.6 L21,17.4 C21,18.2836556 20.4201608,19 19,19 L5,19 C3.57983921,19 3,18.2836556 3,17.4 L3,4.6 C3,3.7163444 3.57983921,3 5,3 Z M12,18 C12.2761424,18 12.5,17.7761424 12.5,17.5 C12.5,17.2238576 12.2761424,17 12,17 C11.7238576,17 11.5,17.2238576 11.5,17.5 C11.5,17.7761424 11.7238576,18 12,18 Z" fill="#000000" fill-rule="nonzero"/>
                                    <polygon fill="#000000" opacity="0.3" points="5 5 5 16 19 16 19 5"/>
                                    <rect fill="#000000" opacity="0.3" x="10" y="20" width="4" height="1" rx="0.5"/>
                                </g>
                            </svg>
                            ` : `
                            <svg viewBox="0 0 24 24" version="1.1" class="kt-svg-icon" style="height:30px; width:30px; float:right;">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <rect x="0" y="0" width="24" height="24"/>
                                    <path d="M8,2.5 C7.30964406,2.5 6.75,3.05964406 6.75,3.75 L6.75,20.25 C6.75,20.9403559 7.30964406,21.5 8,21.5 L16,21.5 C16.6903559,21.5 17.25,20.9403559 17.25,20.25 L17.25,3.75 C17.25,3.05964406 16.6903559,2.5 16,2.5 L8,2.5 Z" fill="#000000" opacity="0.3"/>
                                    <path d="M8,2.5 C7.30964406,2.5 6.75,3.05964406 6.75,3.75 L6.75,20.25 C6.75,20.9403559 7.30964406,21.5 8,21.5 L16,21.5 C16.6903559,21.5 17.25,20.9403559 17.25,20.25 L17.25,3.75 C17.25,3.05964406 16.6903559,2.5 16,2.5 L8,2.5 Z M8,1 L16,1 C17.5187831,1 18.75,2.23121694 18.75,3.75 L18.75,20.25 C18.75,21.7687831 17.5187831,23 16,23 L8,23 C6.48121694,23 5.25,21.7687831 5.25,20.25 L5.25,3.75 C5.25,2.23121694 6.48121694,1 8,1 Z M9.5,1.75 L14.5,1.75 C14.7761424,1.75 15,1.97385763 15,2.25 L15,3.25 C15,3.52614237 14.7761424,3.75 14.5,3.75 L9.5,3.75 C9.22385763,3.75 9,3.52614237 9,3.25 L9,2.25 C9,1.97385763 9.22385763,1.75 9.5,1.75 Z" fill="#000000" fill-rule="nonzero"/>
                                </g>
                            </svg>`}
                        </div>                                                      
                </div>` : ``)
            }
        };

       

        if (mMaster?.Type != str_Single) waitingdataTableFields.splice(1, 0, waitingplayer2Field);
        

        // const dataWaitingTable = $('#tblMatchPlayWaiting').KTDatatable({
        //     data    : { saveState: false, source: registerList.filteredWaitingList },
        //     layout  : { scroll: true, footer: false }, sortable: false, pagination: false,
        //     search  : { input: $('#matchPlayRegisterSearch') },
        //     columns : waitingdataTableFields,
        //     rows: { autoHide: false }
        // });

        const dataWaitingTable = $('#tblMatchPlayWaiting').KTDatatable({
            data: {
                saveState: false,
                source: registerList.filteredWaitingList,
                pageSize: 10
            },
            layout: {
                scroll: true,
                height: 700,
                footer: false
            },
            sortable: false,
            pagination: true,
            search: {
                input: $('#matchPlayRegisterSearch')
            },
            columns: waitingdataTableFields,
            rows: {
                autoHide: false
            }
        });
        
        Config.Core.InitPopover();
        $('.custom_table_header').remove();
        setTimeout(() => { 
            if ($('#tblMatchPlayWaiting .kt-datatable__head.custom_table_header').length === 0) {
                $('#tblMatchPlayWaiting > .kt-datatable__table').prepend('<thead class="kt-datatable__head custom_table_header"><tr class="kt-datatable__row"><th class="kt-datatable__cell kt-datatable__cell--sort center">Waiting List</th></tr></thead>') 
            }
        }, 100)            

        dataTable?.on('click', '.btn-edit', function (ss) {          
            const index = $(ss.currentTarget).parents('tr').index();               
            if (dataTable.dataSet && dataTable.dataSet.length > 0 && dataTable.dataSet[index]) {
                setSelectedRegister(dataTable.dataSet[index]);              
                setShowModal(true);
            } 
        });

        //reg delete onclick
        dataTable?.on('click', '.btn-delete-register', function (ss) {          
            const index = $(ss.currentTarget).parents('tr').index();               
            if (dataTable.dataSet && dataTable.dataSet.length > 0 && dataTable.dataSet[index]) {               
               const registerID = dataTable.dataSet[index]?.ID;
               deleteMatchPlayRegistration(registerID, 'confirm');
            } 
        });

        //reg delete onclick
        dataWaitingTable?.on('click', '.btn-delete-waiting', function (w) {          
            const index = $(w.currentTarget).parents('tr').index();               
            if (dataWaitingTable.dataSet && dataWaitingTable.dataSet.length > 0 && dataWaitingTable.dataSet[index]) {                
                const waitingID = dataWaitingTable.dataSet[index]?.ID;
                deleteMatchPlayRegistration(waitingID, 'waiting');
            } 
        });
    }
  
    const onSelectHandler =(mMaster)=> {
        if(!mMaster) return;       
        setMMaster(mMaster);                                     
    }
    
    //Reset on drawer close
    const onReset =()=> {
        setMMaster();        
        setPageData({});

        $('#tblMatchPlayRegister').KTDatatable().destroy();          //Reset Ktdatatable
        $('#tblMatchPlayWaiting').KTDatatable().destroy();
        setIsInit(true);
    }

    const closeRegisterModal =()=> { 
        setShowModal(false);
        if(!!selectedRegister) setSelectedRegister();
    }

    
    const refetchMatchPlayData = ()=>  fetchMatchPlayData(mMaster?.ID);
    const showRegisterModal     = ()=> setShowModal(true);

    //#endregion
    
    return(<>
        <MatchPlayList matchPlayID={matchPlayID} setMatchPlayID={setMatchPlayID} title={"Registration"}  comp={"register"} onSelectHandler={onSelectHandler}  resetData={onReset}>
            <div className="kt-portlet">
                <div className="kt-portlet__body padding-t10 padding-b0">
                    
                    <div className="kt-portlet__head kt-portlet__head--lg padding-l0 border-b0">                               
                        <div className="flex-container flex-grow-03 margin-l20 margin-t10">
                            <div className="flex-item flex-grow-03">
                                <div className="kt-input-icon kt-input-icon--left">
                                    <input type="text" className="form-control clientSearch" placeholder="Search Player..." id="matchPlayRegisterSearch" />
                                    <span className="kt-input-icon__icon kt-input-icon__icon--left"><span><i className="la la-search"></i></span></span>
                                </div>
                            </div>

                        </div>
                        <div className="kt-portlet__head-toolbar">
                            <div className="kt-portlet__head-wrapper">
                                <div className="kt-portlet__head-actions">
                                    {/* <button id="btnRefresh" type="button" data-toggle="modal" data-target="#updateHandicapModal" className="btn btn-success btn-icon-sm text-white d-inline"><i className="la la-refresh"></i>Refresh Handicap</button> */}
                                    
                                    {!IsDeadlineCreated && (
                                        <button id="btnAddNew" type="button" className="btn btn-brand btn-icon-sm text-white d-inline margin-l5"
                                            onClick={showRegisterModal}
                                        ><i className="la la-plus"></i> Add New </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {!!mMaster && (
                        <div id="matchPlayInfoPanel" className="kt-notification margin-t10 mb-3 margin-lr20 bg-lightGrey">
                            <div className="kt-notification__item d-block">
                                <div className="row">
                                    <div className="col-8">
                                        <div className="kt-user-card-v2 mb-2">
                                            <div className="kt-user-card-v2__pic">
                                                <img id="txtMatchPlayImg" src={mMaster.Icon} alt="matchPlay-logo" />
                                            </div>
                                            <div className="kt-user-card-v2__details ">
                                                <span id="txtMatchPlay" className="kt-user-card-v2__name text-clip"> {mMaster?.Name} </span>
                                                <span className="kt-user-card-v2__desc ">
                                                    <span id="txtType"> {mMaster?.Type} </span> | <span id="txtMembership">  {mMaster?.MembershipType} </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="col-2 d-flex-center">
                                        <div className="kt-user-card-v2 mb-2">
                                            <div className="kt-user-card-v2__details ">
                                                <span className="kt-user-card-v2__name "> Start </span>
                                                <span className="kt-user-card-v2__desc">
                                                    <span id="txtStartDate"> {moment(mMaster?.StartDate).format('DD-MMM-YYYY')} </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-2 d-flex-center">
                                        <div className="kt-user-card-v2 mb-2">
                                            <div className="kt-user-card-v2__details ">
                                                <span className="kt-user-card-v2__name"> End </span>
                                                <span className="kt-user-card-v2__desc ">
                                                    <span id="txtEndDate"> {moment(mMaster?.EndDate).format('DD-MMM-YYYY')} </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    <div id="tblMatchPlayRegister" className="table-bordered table-hover table-header-grey custom-datatable margin-lr20 margin-b30"></div>
                    <div id="tblMatchPlayWaiting" className="table-bordered table-hover table-header-grey custom-datatable margin-lr20 margin-b30"></div>
                </div>
            </div>
        </MatchPlayList>   

        {!!showModal && (
            <RegisterModal
                show             ={showModal}
                onDismissModal   ={closeRegisterModal}
                mMaster          ={mMaster}
                mData            ={pageData}
                refetchData      ={()=> refetchMatchPlayData()}
                selectedRegister ={selectedRegister}
            />
        )} 
    </>)
}

export default MatchPlayRegistration;